import { useSnackbarNotification } from "components/SnackbarNotifications";
import { useAuth } from "contexts/AuthContext";
import { useState } from "react";
import { sendErrorEmail } from "utils/sendEmail";
import { ReactComponent as GoogleLogo } from "assets/images/icon-google.svg";

import { useGoogleLogin } from "@react-oauth/google";
import Button from "components/Button";

const WebGoogleButton = ({ text }) => {
  const { handleGoogleLogin } = useAuth();
  const { openGeneralErrorSnackbar } = useSnackbarNotification();
  const [isLoading, setIsLoading] = useState(false);

  const fetchUserProfile = async (accessToken) => {
    try {
      const response = await fetch(
        "https://www.googleapis.com/oauth2/v2/userinfo",
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch user profile");
      }

      return await response.json();
    } catch (error) {
      throw new Error(`Profile fetch error: ${error.message}`);
    }
  };
  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      setIsLoading(true);
      try {
        // Fetch user profile using the access token
        const userProfile = await fetchUserProfile(tokenResponse.access_token);

        // Transform to match your expected format
        const user = {
          name: userProfile.name,
          email: userProfile.email,
          picture: userProfile.picture,
          googleId: userProfile.id,
        };

        console.log("User profile:", user);

        // Call your existing auth handler
        handleGoogleLogin(user, (status) => setIsLoading(status));
      } catch (error) {
        console.error("Google login error:", error);
        openGeneralErrorSnackbar();
        sendErrorEmail(JSON.stringify(error), "Google login error");
        setIsLoading(false);
      }
    },
    onError: (error) => {
      console.error("Google OAuth error:", error);
      openGeneralErrorSnackbar();
      sendErrorEmail(JSON.stringify(error), "Google OAuth error");
    },
  });

  return (
    <Button
      size="medium"
      className="social-button google font-regular"
      variation="square-rounded"
      theme="primary"
      onClick={login}
      disabled={isLoading}
    >
      <GoogleLogo />
      {isLoading ? "Loading..." : text}
    </Button>
  );
};

export default WebGoogleButton;
